export default "__VITE_ASSET__CKzkO1vm__"